
import OfflineSvg from '../../../static/assets/offline_error.svg';
import { SIGN_OUT_OF_SSO } from '../../../static/keyWords.js';
import { messageManager } from '../../System/messageManager/messageManager.js';

export const getErrorPagesByType = (nameConventions, helperFunction) => {
  const messages = messageManager(nameConventions).ERROR_PAGES;

  const navigateToHome = () => window.location.href = '/';

  return {
    COMING_SOON: {
      imageSrc: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/coming-soon-spot-hero.svg',
      alt: 'Coming Soon',
      title: messages.PAGE_COMING_SOON_TITLE,
      message: messages.PAGE_COMING_SOON_MESSAGE,
      buttons: [
        {
          label: messages.PAGE_NOT_FOUND_GO_BACK,
          variant: 'raised',
          onClick: navigateToHome,
        },
      ]
    },
    PAGE_NOT_FOUND: {
      imageSrc: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/404-error-spot-hero.svg',
      alt: 'Page Not Found',
      title: messages.PAGE_NOT_FOUND_TITLE,
      message: messages.PAGE_NOT_FOUND_MESSAGE,
      buttons: [
        {
          label: messages.PAGE_NOT_FOUND_GO_BACK,
          variant: 'raised',
          onClick: navigateToHome,
        },
      ]
    },
    PAGE_OUT_OF_DATE_BROWSER: {
      imageSrc: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/unsupported-browser-error-spot-hero.svg',
      alt: 'Out of Date Browser',
      title: messages.PAGE_OUT_OF_DATE_BROWSER_TITLE,
      message: messages.PAGE_OUT_OF_DATE_BROWSER_MESSAGE,
      buttons: [
        {
          label: messages.PAGE_OUT_OF_DATE_BROWSER_UPDATE_BUTTON,
          variant: 'raised',
          onClick: () => window.open('https://browsehappy.com/', '_blank'),
        },
      ]
    },
    PAGE_UNSUPPORTED_BROWSER: {
      imageSrc: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/unsupported-browser-error-2-spot-hero.svg',
      alt: 'Unsupported Browser',
      title: messages.PAGE_UNSUPPORTED_BROWSER_TITLE,
      message: messages.PAGE_UNSUPPORTED_BROWSER_MESSAGE,
      buttons: [
        {
          label: messages.PAGE_NOT_FOUND_GO_BACK,
          variant: 'raised',
          onClick: navigateToHome,
        },
      ]
    },
    PAGE_UNAUTHORIZED_ACCESS: {
      imageSrc: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/403-error-spot-hero.svg',
      alt: 'Unauthorized Access',
      title: messages.PAGE_UNAUTHORIZED_ACCESS_TITLE,
      message: messages.PAGE_UNAUTHORIZED_ACCESS_MESSAGE,
      buttons: [
        {
          label: messages.PAGE_NOT_FOUND_GO_BACK,
          variant: 'raised',
          onClick: navigateToHome,
        }
      ]
    },
    PAGE_OFFLINE: {
      imageSrc: OfflineSvg,
      alt: 'Page Offline',
      title: messages.PAGE_OFFLINE_TITLE,
      message: messages.PAGE_OFFLINE_MESSAGE,
      buttons: [
        {
          label: messages.PAGE_NOT_FOUND_GO_BACK,
          variant: 'raised',
          onClick: navigateToHome,
        },
        {
          label: messages.PAGE_NOT_FOUND_REFRESH,
          variant: 'outlined',
          onClick: () => window.location.reload(),
        }
      ]
    },
    PAGE_INTERNAL_ERROR: {
      imageSrc: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/500-error-spot-hero.svg',
      alt: 'Internal Error',
      title: messages.PAGE_INTERNAL_ERROR_TITLE,
      message: messages.PAGE_INTERNAL_ERROR_MESSAGE,
      buttons: [
        {
          label: messages.PAGE_NOT_FOUND_GO_BACK,
          variant: 'raised',
          onClick: navigateToHome,
        },
        {
          label: messages.PAGE_INTERNAL_ERROR_CONTACT_ADMIN,
          variant: 'outlined',
          onClick: navigateToHome,
        }
      ]
    },
    FORBIDDEN_ACCESS: {
      imageSrc: 'https://cdn.forge.tylertech.com/v1/images/spot-hero/403-error-2-spot-hero.svg',
      alt: 'Forbidden Access',
      title: messages.PAGE_FORBIDDEN_ACCESS_TITLE,
      message: messages.PAGE_FORBIDDEN_ACCESS_MESSAGE,
      buttons: [
        {
          label: messages.PAGE_NOT_FOUND_GO_BACK,
          variant: 'raised',
          onClick: navigateToHome,
        },
      ]
    },
    EMAIL_MISMATCH: {
      imageSrc: 'https://cdn.forge.tylertech.com/v1/images/spot/person-to-person-spot.svg',
      alt: 'Email Mismatch',
      title: messages.EMAIL_MISMATCH,
      message: messages.EMAIL_MISMATCH_MESSAGE,
      buttons: [
        {
          label: messages.TRY_AGAIN,
          variant: 'outlined',
          onClick: navigateToHome,
        },
        {
          label: SIGN_OUT_OF_SSO,
          variant: 'raised',
          onClick: () => helperFunction && helperFunction(),
        }
      ]
    }
  };
};
